<template>
  <div>
    <div class="skin-descriptions_table card-dark">
      <div
        v-if="item.category"
        class="skin-descriptions_table--row"
      >
        <span>{{ t('Type') }}</span>
        <nuxt-link
          :to="getAllWeaponsPageLink(item.category)"
          class="text"
        >
          {{
            item.category
          }}
        </nuxt-link>
      </div>
      <div
        v-if="item.weapon"
        class="skin-descriptions_table--row"
      >
        <span>{{ t('Weapon') }}</span>
        <nuxt-link
          :to="getWeaponLink(item.weapon)"
          class="text"
        >
          {{ item.weapon }}
        </nuxt-link>
      </div>
      <div
        v-if="item.locals.localed_name || item.market_hash_name"
        class="skin-descriptions_table--row"
      >
        <span>{{ t('Finish') }}</span>
        <p>{{ getItemNameOnly(item.locals.localed_name || item.market_hash_name) }}</p>
      </div>
      <div
        v-if="item.locals?.rarity"
        class="skin-descriptions_table--row"
      >
        <span>{{ t('Rarity') }}</span>
        <p>{{ item.locals?.rarity }}</p>
      </div>
      <div
        v-if="item.exterior"
        class="skin-descriptions_table--row"
      >
        <span>{{ t('Exterior') }}</span>
        <p>{{ item.exterior }}</p>
      </div>
      <!--      <div -->
      <!--          v-if="item.descriptions.finish_style" -->
      <!--          class="skin-descriptions_table&#45;&#45;row" -->
      <!--      > -->
      <!--        <span>{{ t('Finish Style') }}</span> -->
      <!--        <p>{{ item.descriptions.finish_style }}</p> -->
      <!--      </div> -->
      <!--        <div -->
      <!--            v-if="item.descriptions.finish_catalog" -->
      <!--            class="skin-descriptions_table&#45;&#45;row" -->
      <!--        > -->
      <!--          <span>{{ t('Finish Catalog') }}</span> -->
      <!--          <p>{{ item.descriptions.finish_catalog }}</p> -->
      <!--        </div> -->
      <div
        v-if="item.popularity"
        class="skin-descriptions_table--row"
      >
        <span>{{ t('Popularity') }}</span>
        <p>{{ t(item.popularity) }}</p>
      </div>
      <template v-if="item.designers?.length">
        <div
          v-for="designer in item.designers"
          :key="designer.designer_name"
          class="skin-descriptions_table--row"
        >
          <span>{{ t('Designer') }}</span>
          <a
            v-if="designer?.designer_profile_url"
            :href="designer?.designer_profile_url"
            class="gr-text"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            {{ designer?.designer_name }}
          </a>
          <p
            v-else
            class="gr-text"
          >
            {{ designer?.designer_name }}
          </p>
        </div>
      </template>
      <div
        v-if="item.workshop_link"
        class="skin-descriptions_table--row"
      >
        <span>{{ t('Workshop') }}</span>
        <a
          :href="item.workshop_link"
          class="gr-text"
          rel="nofollow"
          target="_blank"
        >
          {{ 'View Submission' }}
        </a>
      </div>
      <!--        <div -->
      <!--            v-if="item.descriptions.released" -->
      <!--            class="skin-descriptions_table&#45;&#45;row" -->
      <!--        > -->
      <!--          <span>{{ t('Released') }}</span> -->
      <!--          <p> -->
      <!--            {{ -->
      <!--              moment(new Date(item.descriptions.released)).format('DD.MM.YYYY') -->
      <!--            }} -->
      <!--          </p> -->
      <!--        </div> -->
      <div
        v-if="item.update_text"
        class="skin-descriptions_table--row"
      >
        <span>{{ t('Update') }}</span>
        <a
          v-if="item.update_link"
          :href="item.update_link"
          rel="nofollow"
        >{{
          item.update_text
        }}</a>
        <p v-else>
          {{ item.update_text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ItemPageInfo } from '~/graphql/generated/schema-types';

defineProps<{
  item: ItemPageInfo
}>();

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.skin-descriptions_table {
  padding: 8px 16px;

  &--row {
    border-top: 1px solid #252930;
    padding-top: 8px;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    &:first-child {
      border-color: transparent;
    }

    span {
      color: var(--gray);
      font-size: 1.4rem;
    }

    p, a.text {
      font-size: 1.6rem;
      font-weight: 600;
      text-align: right;
    }

    a.text:hover {
      text-decoration: underline;
    }

    a.gr-text {
      font-size: 1.6rem;
      font-weight: 800;
      position: relative;
      padding: 0.2rem 0;

      &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0.2rem;
        //width: 100%;
        height: 1px;
        background: var(--gr-primary);
        width: 0;
        opacity: 0;
        visibility: hidden;
        transition: 0.3s;
      }

      &:hover {
        &:after {
          width: 100%;
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
}
</style>
